/**
 * Is Valid CSS Value Utility
 *
 * Utility function for validating if a value is a valid CSS length/size value
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Validate if a value is a valid CSS length/size value
 */
export const isValidCSSValue = (
	value: string | number | undefined,
): boolean => {
	if ( ! value || value === '' ) return true;
	if ( value === 'auto' ) return true;

	const stringValue = String( value );

	// Check if it's a valid CSS length value
	return /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ch|ex|cm|mm|in|pt|pc|vmin|vmax)?$/.test(
		stringValue,
	);
};
